import React from 'react';
import {connect} from 'react-redux';
import numeral from 'numeral';
import moment from 'moment';
import map from 'lodash/map';
import Chart from 'chart.js';

import selectEntities from '../../../../../../selectors/entities';
import {
  fetchStatsIfNeeded,
  refreshStats,
} from '../../../../../../actions/app/other/mpm/users';
import './index.css';
import Loader from '../../../../../../components/Loader';
import DateRangePickerWrapper from '../../../../../../components/DatePicker/DateRangePickerWrapper';
import earthFlag from '../../../../../../assets/img/other/flag-earth.svg';

let chart;

class MPMRegistrationsWidget extends React.Component {
  constructor(props) {
    super(props);

    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
    const start = moment(today.setDate(today.getDate() - 30)).format(
      'YYYY-MM-DD',
    );

    this.state = {end, start};
  }

  fetchStats() {
    const {end, start} = this.state;
    this.props.dispatch(fetchStatsIfNeeded({end, start}));
  }

  refreshStats() {
    const {end, start} = this.state;
    this.props.dispatch(refreshStats({end, start}));
  }

  componentDidMount() {
    this.fetchStats();

    const ctx = document.getElementById('newMembersChart');
    if (ctx)
      chart = new Chart(ctx, {
        type: 'bar',
        data: {datasets: []},
        options: {
          scales: {
            xAxes: [
              {
                id: 'date',
                type: 'time',
                stacked: true,
              },
            ],
            yAxes: [
              {
                id: 'members',
                type: 'linear',
                stacked: true,
              },
            ],
          },
        },
      });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.widget.ids !== this.props.widget.ids) {
      const {entities} = nextProps.statistics;

      const datasets = [
        {
          label: 'Old MPG/MPP FR',
          backgroundColor: '#ed9728',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
        {
          label: 'Old MPG/MPP EN',
          backgroundColor: '#9fc99e',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
        {
          label: 'Old MPG/MPP ES',
          backgroundColor: '#819bb7',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
        {
          label: 'Old MPG/MPP OTHER',
          backgroundColor: 'blue',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
        {
          label: 'MPM FR',
          backgroundColor: '#39796b',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
        {
          label: 'MPM EN',
          backgroundColor: '#a98274',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
        {
          label: 'MPM ES',
          backgroundColor: '#dd9189',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
        {
          label: 'MPM OTHER',
          backgroundColor: 'brown',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
      ];

      map(entities, stat => {
        datasets[0].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat.mpgFr, 10),
        });
        datasets[1].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat.mpgEn, 10),
        });
        datasets[2].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat.mpgEs, 10),
        });
        datasets[3].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat.mpgOther, 10),
        });
        datasets[4].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat.mpmFr, 10),
        });
        datasets[5].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat.mpmEn, 10),
        });
        datasets[6].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat.mpmEs, 10),
        });
        datasets[7].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat.mpmOther, 10),
        });
      });

      chart.data.datasets = datasets;
      chart.update();
    }
  }

  getSum(entities) {
    let sum = {
      MPM_FR: 0,
      MPM_GB: 0,
      MPM_ES: 0,
      MPM_OTHER: 0,
      FR: 0,
      GB: 0,
      ES: 0,
      OTHER: 0,
    };

    entities.map(item => {
      sum.FR += item.mpgFr || 0;
      sum.GB += item.mpgEn || 0;
      sum.ES += item.mpgEs || 0;
      sum.OTHER += item.mpgOther || 0;

      sum.MPM_FR += item.mpmFr || 0;
      sum.MPM_GB += item.mpmEn || 0;
      sum.MPM_ES += item.mpmEs || 0;
      sum.MPM_OTHER += item.mpmOther || 0;

      return {data: item, amount: sum};
    });

    return sum;
  }

  render() {
    const {end, start} = this.state;
    const {info} = this.props.widget;
    let {entities, total} = this.props.statistics;
    const sum = this.getSum(entities);

    const sumTotal =
      sum.ES +
      sum.FR +
      sum.GB +
      sum.OTHER +
      sum.MPM_ES +
      sum.MPM_FR +
      sum.MPM_GB +
      sum.MPM_OTHER;

    return (
      <div id="registrations-widget" className="row">
        <div className="col-md-12">
          <div className="box">
            <div className="box-header with-border">
              <h3 className="box-title pull-left">
                <i className="fa fa-user-plus" /> Registrations / New members
              </h3>
              <div className="box-tools pull-right">
                <button
                  type="button"
                  className="btn btn-box-tool"
                  onClick={() => this.refreshStats()}>
                  <i className="fa fa-refresh" />
                </button>
                <button
                  type="button"
                  className="btn btn-box-tool"
                  data-widget="collapse">
                  <i className="fa fa-minus" />
                </button>
              </div>
            </div>
            <div className="box-body">
              <div className="text-center margin-bottom">
                New members from
                <div className="inline data-range-picker">
                  <DateRangePickerWrapper
                    initialStartDate={moment(start)}
                    initialEndDate={moment(end)}
                    minimumNights={0}
                    onDatesChange={({startDate, endDate}) => {
                      this.setState({
                        start: moment(startDate).format('YYYY-MM-DD'),
                        end: moment(endDate).format('YYYY-MM-DD'),
                      });
                    }}
                  />
                  <button
                    className="btn btn-default"
                    onClick={() => this.refreshStats()}>
                    <i className="fa fa-refresh" />
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="chart">
                    <canvas id="newMembersChart" />
                  </div>
                </div>
                <div className="col-md-6 row">
                  <div className="table-responsive table-fixed-height text-center">
                    <table className="table table-bordered no-margin">
                      <thead>
                        <tr>
                          <th></th>
                          <th className="text-center" colspan="4">
                            Old MPG/MPP
                          </th>
                          <th className="text-center" colspan="4">
                            New MPM
                          </th>
                        </tr>
                        <tr>
                          <th>Day</th>
                          <th className="text-center">
                            <i className="flag-icon flag-icon-fr" />
                          </th>
                          <th className="text-center">
                            <i className="flag-icon flag-icon-gb" />
                          </th>
                          <th className="text-center">
                            <i className="flag-icon flag-icon-es" />
                          </th>
                          <th className="text-center">
                            <img
                              src={earthFlag}
                              alt="Drapeau de la terre"
                              className="flag-img"
                            />
                          </th>
                          <th className="text-center">
                            <i className="flag-icon flag-icon-fr" />
                          </th>
                          <th className="text-center">
                            <i className="flag-icon flag-icon-gb" />
                          </th>
                          <th className="text-center">
                            <i className="flag-icon flag-icon-es" />
                          </th>
                          <th className="text-center">
                            <img
                              src={earthFlag}
                              alt="Drapeau de la terre"
                              className="flag-img"
                            />
                          </th>
                          <th className="text-center">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {entities.map((item, index) => {
                          const total =
                            item.mpgFr +
                            item.mpgEn +
                            item.mpgEs +
                            item.mpgOther +
                            item.mpmFr +
                            item.mpmEn +
                            item.mpmEs +
                            item.mpmOther;
                          return (
                            <tr key={index} className="text-center">
                              <td className="text-left">
                                {moment(item.date).format('LL')}
                              </td>
                              <td>{item.mpgFr}</td>
                              <td>{item.mpgEn}</td>
                              <td>{item.mpgEs}</td>
                              <td>{item.mpgOther}</td>
                              <td>{item.mpmFr}</td>
                              <td>{item.mpmEn}</td>
                              <td>{item.mpmEs}</td>
                              <td>{item.mpmOther}</td>
                              <td>{total}</td>
                            </tr>
                          );
                        })}
                        {entities.length > 0 && (
                          <tr key="all" className="text-center">
                            <td className="text-left">
                              Sum from {moment(start).format('LL')} to &nbsp;
                              {moment(end).format('LL')}
                            </td>
                            <td>{sum.FR}</td>
                            <td>{sum.GB}</td>
                            <td>{sum.ES}</td>
                            <td>{sum.OTHER}</td>
                            <td>{sum.MPM_FR}</td>
                            <td>{sum.MPM_GB}</td>
                            <td>{sum.MPM_ES}</td>
                            <td>{sum.MPM_OTHER}</td>
                            <td>{sumTotal}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {total && (
              <div className="box-footer">
                <div className="row">
                  <div className="col-xs-12 col-md-4">
                    <div className="description-block border-right">
                      <h5 className="description-header">
                        {numeral(total.mpmFr, 10).format('0,0')}
                      </h5>
                      <span className="description-text text-green">FR</span>
                    </div>
                  </div>
                  <div className="col-xs-6 col-md-4">
                    <div className="description-block border-right">
                      <h5 className="description-header">
                        {numeral(total.mpmEn, 10).format('0,0')}
                      </h5>
                      <span className="description-text text-blue">GB</span>
                    </div>
                  </div>
                  <div className="col-xs-6 col-md-4">
                    <div className="description-block">
                      <h5 className="description-header">
                        {numeral(total.mpmEs, 10).format('0,0')}
                      </h5>
                      <span className="description-text text-red">ES</span>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-6">
                    <div className="description-block border-right">
                      <h5 className="description-header">
                        {numeral(total.mpmOther, 10).format('0,0')}
                      </h5>
                      <span className="description-text">Other</span>
                    </div>
                  </div>
                  <div className="col-xs-6">
                    <div className="description-block border-right">
                      <h5 className="description-header">
                        {numeral(total.all, 10).format('0,0')}
                      </h5>
                      <span className="description-text">All</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {info.isFetching && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => {
    const {statistics} = state.entities;
    const {userStats} = state.app.other.mpm;

    return {
      widget: userStats,
      statistics: {
        entities: selectEntities(statistics, userStats.ids),
        total: userStats.total,
      },
    };
  },
  dispatch => ({dispatch}),
)(MPMRegistrationsWidget);



// WEBPACK FOOTER //
// ./src/pages/Other/MPM/Stats/Widgets/Registrations/index.js